// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen,
  Task
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  campaign: Task,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const campaign: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="campaign Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [

    {
      id: 'sponsors',
      title: <FormattedMessage id="sponsors" />,
      type: 'collapse',
      icon: icons.sponsors,
      children: [
        {
          id: 'sponsor-list',
          title: <FormattedMessage id="sponsor-list" />,
          type: 'item',
          url: '/apps/sponsors/sponsor-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-sponsor',
          title: <FormattedMessage id="add-new-sponsor" />,
          type: 'item',
          url: '/apps/sponsors/add-new-sponsor'
        }
      ]
    },
    {
      id: 'campaign',
      title: <FormattedMessage id="campaign" />,
      type: 'collapse',
      icon: icons.campaign,
      children: [
        {
          id: 'campaign-list',
          title: <FormattedMessage id="Campaign List" />,
          type: 'item',
          url: '/apps/campaign/campaign-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-campaign',
          title: <FormattedMessage id="Add Campaign" />,
          type: 'item',
          url: '/apps/campaign/add-new-campaign'
        }
      ]
    },
    {
      id: 'credits',
      title: <FormattedMessage id="Credit Buy" />,
      type: 'collapse',
      icon: icons.campaign,
      children: [
        {
          id: 'credit-list',
          title: <FormattedMessage id="Credit List" />,
          type: 'item',
          url: '/apps/credits/credit-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-credit',
          title: <FormattedMessage id="Add Credit" />,
          type: 'item',
          url: '/apps/credits/add-new-credit'
        }
      ]
    },
    {
      id: 'promocode',
      title: <FormattedMessage id="promocode" />,
      type: 'collapse',
      icon: icons.promocode,
      children: [
        {
          id: 'promocode-list',
          title: <FormattedMessage id="promocode-list" />,
          type: 'item',
          url: '/apps/promocode/promocode-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-promocode',
          title: <FormattedMessage id="add-new-promocode" />,
          type: 'item',
          url: '/apps/promocode/add-new-promocode'
        }
      ]
    },
  ]
};

export default campaign;
